import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import useForm from "react-hook-form";
import { translator } from "../../utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword, login } from "../../utils/session";
import { Trans } from "@lingui/macro";
import CloseIcon from "@material-ui/icons/Close";
import { Button, Tooltip, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { closeMainDialog } from "../../actions";
import { initValues, updatePasswordReset } from "../../utils/fetcher";
import { connect } from "react-redux";

function ConnexionPatientArea(props) {
  const { handleSubmit, register, errors, getValues } = useForm();

  const dispatch = useDispatch();
  const message = useSelector(state => state.messageWithCode);
  const messageConnexion = useSelector(state => state.message);
  const [messageRequiredEmail, setMessageRequiredEmail] = useState("");
  const forgetPassword = email => dispatch(forgotPassword({ email: email }));
  const connexionPatient = values => dispatch(login(values));
  const [resetPassword, setResetPassword] = useState("initial");
  const [errorMessageResetPassword, setErrorMessageResetPassword] = useState(
    ""
  );
  const [emailResetPassword, setEmailResetPassword] = useState("");
  const [reinitializedpassword, setReinitializedPassword] = useState("");
  const [isLengthValid, setIsLengthValid] = useState(false);
  const [isUppercaseValid, setIsUppercaseValid] = useState(false);
  const [isLowercaseValid, setIsLowercaseValid] = useState(false);
  const [isNumberValid, setIsNumberValid] = useState(false);
  const [isSpecialCharValid, setIsSpecialCharValid] = useState(false);
  const [alert, setAlert] = useState({ type: null, message: "" });

  const noClose = initValues().noClose;

  useEffect(() => {
    validatePasswordConditions();
    if (props.state) {
      setResetPassword(props.state);
    }
  }, [props.state, reinitializedpassword]);

  const forgetPasswordFunc = async email => {
    setErrorMessageResetPassword("");
    if (resetPassword === "initial") {
      setResetPassword("empty");
    } else if (resetPassword === "empty") {
      try {
        const result = await forgetPassword(email);
        if (result.response.result == "ok") {
          setErrorMessageResetPassword("");
          setResetPassword("filled");
        } else {
          setErrorMessageResetPassword(result.response.message);
        }
      } catch (error) {
        console.error(error);
      }
    } else if (resetPassword === "filled") {
      try {
        const result = await forgetPassword(email);
        if (result.response.result == "ok") {
          setAlert({
            type: "success",
            message: `E-mail de réinitialisation envoyé à nouveau.`
          });
        } else {
          setAlert({ type: "error", message: result.response.message });
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleEmailChange = event => {
    const { value } = event.target;
    setEmailResetPassword(value);
  };

  const handlePasswordChange = e => {
    const newPassword = e.target.value;
    setReinitializedPassword(newPassword);
  };

  const validatePasswordConditions = () => {
    setIsLengthValid(reinitializedpassword.length >= 8);
    setIsUppercaseValid(/[A-Z]/.test(reinitializedpassword));
    setIsLowercaseValid(/[a-z]/.test(reinitializedpassword));
    setIsNumberValid(/\d/.test(reinitializedpassword));
    setIsSpecialCharValid(/[!@#$%^&*(),.?":{}|<>]/.test(reinitializedpassword));
  };

  const onSubmit = values => {
    setMessageRequiredEmail("");
    connexionPatient(values);
  };

  const onReinitializedPassword = () => {
    props.updatePassword(
      {
        code: props.code,
        identifiant_user: props.idUser,
        password: reinitializedpassword
      },
      (message, success) => {
        if (success == "erreur") {
          setErrorMessageResetPassword(message);
        } else {
          setResetPassword("initial");
        }
      }
    );
  };

  const closeHandler = () => {
    window.parent.postMessage({ event_id: "closeiframe" }, "*");
    dispatch(closeMainDialog());
  };

  return (
    <div className="wrap-form-login">
      {!noClose && (
        <Tooltip
          className="close-custom-btn"
          title={translator()._("W_STEP_BOUTON_FERMER")}
        >
          <IconButton
            aria-label={translator()._("W_STEP_BOUTON_FERMER")}
            onClick={closeHandler}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      )}
      <div className="column-left">
        <img className="logo" src="images/icon_cp.png" alt="Compte patient" />
      </div>
      {resetPassword == "initial" && (
        <form onSubmit={handleSubmit(onSubmit)} className="form-login">
          {messageConnexion && (
            <div className="custom-message custom-alert d-flex align-items-center mb-10">
              <ErrorIcon />
              {messageConnexion}
            </div>
          )}
          {message && !messageRequiredEmail && message.text && (
            <div
              className={
                message.code === 1
                  ? "custom-message custom-success d-flex align-items-center mb-10"
                  : "custom-message custom-alert d-flex align-items-center mb-10"
              }
            >
              {message.code === 1 ? <CheckCircleIcon /> : <ErrorIcon />}
              <div dangerouslySetInnerHTML={{ __html: message.text }} />
            </div>
          )}
          {messageRequiredEmail && (
            <div className="custom-message custom-alert d-flex align-items-center mb-10">
              <ErrorIcon />
              {messageRequiredEmail}
            </div>
          )}
          <div className="row-form">
            <input
              type="email"
              placeholder={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
              name="email"
              ref={register({
                required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: `${translator()._("W_ADRESSE_E_MAIL_NON_VALIDE")}`
                }
              })}
            />
            <span className="error">
              {errors.email && errors.email.message}
            </span>
          </div>
          <div className="row-form">
            <input
              placeholder={translator()._("CP_PASSWORD")}
              name="password"
              type="password"
              ref={register({
                required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`
              })}
            />
            <span className="error">
              {errors.password && errors.password.message}
            </span>
          </div>
          <div>
            <button
              type="button"
              onClick={() => forgetPasswordFunc(getValues().email)}
              className="forgot-password no-style-btn"
            >
              <Trans id="W_STEP4_ACCES_MEMBRE_MOT_DE_PASSE_OUBLIE" />
            </button>
          </div>
          <Button
            color="primary"
            type="submit"
            className="btn-filled"
            variant="contained"
          >
            {translator()._("W_SE_CONNECTER")}
          </Button>
        </form>
      )}
      {resetPassword == "empty" && (
        <div className="form-login">
          {errorMessageResetPassword != "" && (
            <div className="custom-message custom-alert d-flex align-items-center mb-10">
              <ErrorIcon />
              {errorMessageResetPassword}
            </div>
          )}
          <Typography variant="h5" style={{ fontWeight: "bold" }}>
            Mot de passe oublié ?<br />
            <br />
          </Typography>
          <Typography>
            Veuillez saisir l&apos;adresse email associée à votre compte. Un
            lien
            <br />
            pour réinitialiser votre mot de passe vous sera envoyé.
            <br />
            <br />
          </Typography>
          <div className="row-form">
            <input
              type="email"
              placeholder="Adresse email"
              name="email"
              onChange={handleEmailChange}
              value={emailResetPassword}
              ref={register({
                required: "Ce champ est obligatoire",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Adresse e-mail non valide"
                }
              })}
              style={{ width: "17rem" }}
            />
            <span className="error">
              {errors.email && errors.email.message}
            </span>
          </div>
          <Button
            color="primary"
            type="submit"
            className="btn-filled"
            variant="contained"
            onClick={() => forgetPasswordFunc(emailResetPassword)}
          >
            Réinitialiser le mot de passe
          </Button>
        </div>
      )}
      {resetPassword == "filled" && (
        <div className="form-login" style={{ textAlign: "center" }}>
          {alert.type && (
            <div
              className={`custom-message custom-${
                alert.type == "success" ? "success" : "alert"
              } d-flex align-items-center mb-10`}
            >
              {alert.type === "success" ? <CheckCircleIcon /> : <ErrorIcon />}
              {alert.message}
            </div>
          )}

          <Typography>
            Les instructions pour réinitialiser votre mot de
            <br />
            <span>passe vous ont été envoyées par email sur</span> <br />
            <span style={{ fontWeight: "bold" }}>{emailResetPassword}</span>
            <br />
            <br />
          </Typography>
          <Typography>
            Si l&apos;email n&apos;arrive pas assurez-vous de verifier
            <br />
            votre dossier spam.
            <br />
            <br />
          </Typography>
          <Typography
            onClick={() => forgetPasswordFunc(emailResetPassword)}
            className="forgot-password no-style-btn"
          >
            Renvoyer l&apos;email
          </Typography>
        </div>
      )}
      {resetPassword == "expired" && (
        <div className="form-login" style={{ textAlign: "center" }}>
          <Typography>
            Le lien que vous avez utilisé n&apos;est plus valide. Veuillez
            demander un <br />
          </Typography>
          <Typography>
            nouveau lien de réinitialisation en utilisant le bouton ci-dessous.
            <br />
            <br />
          </Typography>
          <Button
            color="primary"
            type="submit"
            className="btn-filled"
            variant="contained"
            onClick={() => setResetPassword("empty")}
          >
            Réinitialiser le mot de passe
          </Button>
        </div>
      )}
      {resetPassword == "reinitialized" && (
        <div className="form-login">
          {errorMessageResetPassword != "" && (
            <div className="custom-message custom-alert d-flex align-items-center mb-10">
              <ErrorIcon />
              {errorMessageResetPassword}
            </div>
          )}
          <Typography>
            Réinitialiser mon mot de passe
            <br />
            <br />
          </Typography>
          <div className="row-form">
            <input
              placeholder={translator()._("CP_PASSWORD")}
              name="password"
              type="password"
              ref={register({
                required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`
              })}
              onChange={handlePasswordChange}
              style={{ width: "25rem" }}
            />
            <Typography style={{ color: "gray" }}>
              Doit comprendre au moins:
            </Typography>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <CheckCircleIcon
                fontSize="small"
                style={{ color: isLengthValid ? "green" : "red" }}
              />
              <Typography style={{ color: "gray" }}> 8 caractères</Typography>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <CheckCircleIcon
                fontSize="small"
                style={{ color: isUppercaseValid ? "green" : "red" }}
              />
              <Typography style={{ color: "gray" }}>1 majuscule</Typography>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <CheckCircleIcon
                fontSize="small"
                style={{ color: isLowercaseValid ? "green" : "red" }}
              />
              <Typography style={{ color: "gray" }}>1 minuscule</Typography>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <CheckCircleIcon
                fontSize="small"
                style={{ color: isNumberValid ? "green" : "red" }}
              />
              <Typography style={{ color: "gray" }}>1 chiffre</Typography>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <CheckCircleIcon
                fontSize="small"
                style={{ color: isSpecialCharValid ? "green" : "red" }}
              />
              <Typography style={{ color: "gray" }}>
                1 caractère spécial
              </Typography>
            </div>
          </div>
          <Button
            color="primary"
            type="submit"
            className="btn-filled"
            variant="contained"
            disabled={
              !isLengthValid ||
              !isUppercaseValid ||
              !isLowercaseValid ||
              !isNumberValid ||
              !isSpecialCharValid
            }
            onClick={() => onReinitializedPassword()}
          >
            Valider mon nouveau mot de passe
          </Button>
        </div>
      )}
    </div>
  );
}

ConnexionPatientArea.propTypes = {
  state: PropTypes.string,
  code: PropTypes.string,
  idUser: PropTypes.string,
  updatePassword: PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    updatePassword: (values, success) =>
      dispatch(updatePasswordReset(values, success))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(ConnexionPatientArea);
